import { Injectable } from '@angular/core';
import { MediaDepotAsset } from '@mira-avant/mtlibs';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import {} from '@mira-avant/mtlibs';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class MediaDepotService {
	private readonly BASE_PATH = 'media-depot';

	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public assetsBs$: BehaviorSubject<MediaDepotAsset[]> = new BehaviorSubject<MediaDepotAsset[]>([]);

	public addAsset(entry: MediaDepotAsset): void {
		const currentAssets = this.assetsBs$.getValue();
		this.assetsBs$.next([...currentAssets, entry]);
	}

	public addAssets(entries: MediaDepotAsset[]): void {
		const currentAssets = this.assetsBs$.getValue();
		this.assetsBs$.next([...currentAssets, ...entries]);
	}

	constructor(private api: ApiService) {
		this.get$(0, 1000).catch(error => {
			console.error('Error fetching assets:', error);
			this.assetsBs$.next([]);
		});
	}

	private async withLoading<T>(operation: () => Promise<T>): Promise<T> {
		this.loading$.next(true);
		try {
			return await operation();
		} finally {
			this.loading$.next(false);
		}
	}

	public async get$(offset: number, pageSize: number): Promise<MediaDepotAsset[]> {
		return this.withLoading(async () => {
			const assets = await firstValueFrom(
				this.api.get<MediaDepotAsset[]>(this.BASE_PATH + `/get-page/${offset}/${pageSize}`)
			);
			this.assetsBs$.next(assets);
			return assets;
		});
	}

	public async update$(asset: MediaDepotAsset): Promise<MediaDepotAsset> {
		return this.withLoading(async () => {
			const updatedAsset = await firstValueFrom(
				this.api.put<MediaDepotAsset>(this.BASE_PATH + `/${asset.uuid}`, asset)
			);
			const currentAssets = this.assetsBs$.getValue();
			const index = currentAssets.findIndex(a => a.uuid === asset.uuid);

			if (index !== -1) {
				currentAssets[index] = updatedAsset;
				this.assetsBs$.next([...currentAssets]);
			}

			return updatedAsset;
		});
	}
}
